import React from "react"
import { T } from "../../../traks"

export const determinePackageName = (packageId) => {
    switch (packageId) {
        case 1:
            return <T>Primary School</T>
        case 2:
            return <T>Secondary Education</T>
        case 3:
            return <T>Course 100</T>
        case 4:
            return <T>Course 200</T>
        default: 
            return;
    }
}

export const determinePackageDescription = (packageId) => {
    switch (packageId) {
        case 1:
            return <T>(Grades 7–10)</T>
        case 2:
            return <T>(HHX, STX, Gymnasium, etc.)</T>
        default:
            return;
    }   
}

export const determineExtraOptionName = (extraOptionId) => {
    switch (extraOptionId) {
        case "1":
            return <T>5 extra months of premium</T>
        case "2":
            return <T>11 extra months of premium</T>
        default:
            return;
    }
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Cart/CartUtils.js